import type { Capability } from "@redotech/account-common/capability";
import { useRequiredContext } from "@redotech/react-util/context";
import {
  isCapabilityEnabled,
  resolveEnabledCapabilities,
} from "@redotech/redo-team-common/capability-status";
import { useMemo } from "react";
import { TeamContext } from "./team";

/** Whether the active team has this capability on. The only way merchant UI asks. */
export function useCapability(capability: Capability): boolean {
  const team = useRequiredContext(TeamContext);
  return isCapabilityEnabled(team, capability);
}

/** Every capability the active team has on, for code that checks several. */
export function useEnabledCapabilities(): ReadonlySet<Capability> {
  const team = useRequiredContext(TeamContext);
  return useMemo(() => new Set(resolveEnabledCapabilities(team)), [team]);
}
